import { useNavigate } from "react-router-dom";
import "../../styles/visualization/visualizationCard.css";
import { truncateText, formatCount } from "../../utils/text.js";
import { AiOutlineEye, AiOutlineHeart, AiOutlineMessage, AiOutlineLock } from "react-icons/ai";

const MAX_TITLE = 40;
const MAX_DESC = 60;
const MAX_TAGS_VISIBLE = 1;

const VisualizationCard = ({ data }) => {
  const {
    title,
    description,
    tags = [],
    views,
    likesCount,
    commentsCount,
    publicationId,
    accessType,
    price,
    currency = "USD",
  } = data;
  const navigate = useNavigate();
  const visibleTags = tags.slice(0, MAX_TAGS_VISIBLE);
  const extraTags = tags.length - visibleTags.length;

  const isPaid = accessType === "paid";

  return (
    <div
      className={`viz-card ${isPaid ? "viz-card-paid" : ""}`}
      onClick={() => navigate(`/v/visualizations/${publicationId}`)}
    >
      {isPaid && (
        <div className="viz-card-lock">
          <AiOutlineLock size={13} />
          <span>{price > 0 ? `${currency} ${price}` : "Paid"}</span>
        </div>
      )}
      <div className="viz-card-body">
        <h3 className="viz-title">{truncateText(title, MAX_TITLE)}</h3>

        <p className="viz-description">{truncateText(description, MAX_DESC)}</p>

        {tags.length > 0 && (
          <div className="viz-tags">
            {visibleTags.map((tag, idx) => (
              <span key={idx} className="viz-tag">
                #{tag}
              </span>
            ))}

            {extraTags > 0 && (
              <span className="viz-tag more">+{extraTags}</span>
            )}
          </div>
        )}
      </div>

      <div className="card-stats">
        <div className="stat">
          <span className="stat-value">{formatCount(likesCount)}</span>
          <AiOutlineHeart size={20} color="#6b7280" />
        </div>
        <div className="stat">
          <span className="stat-value">{formatCount(views)}</span>
          <AiOutlineEye size={20} color="#6b7280" />
        </div>
        <div className="stat">
          <span className="stat-value">{formatCount(commentsCount)}</span>
          <AiOutlineMessage size={20} color="#6b7280" />
        </div>
      </div>
    </div>
  );
};

export default VisualizationCard;
